export default __webpack_public_path__ + "static/media/Belfort.5efe59b1.png";